module.exports = __webpack_public_path__ + "img/step5-07.4416d014.jpg";